import ServicePage from './page';
import { sipInvestmentsData } from '@/mocks/servicePagesBatch2';

export default function SIPInvestmentsPage() {
  return <ServicePage data={sipInvestmentsData} />;
}